module.exports = __webpack_public_path__ + "img/My Schedule.06235586.png";